import { apiClient } from './client';
import type { CartItem } from '@/stores/cartStore';

// SavedCartController returns raw { items: [...] } — NOT wrapped in ApiResponse,
// so we use apiClient directly instead of the apiGet/apiPut helpers.
export const cartApi = {
  /** Fetch the saved cart from the backend. */
  async getCart(): Promise<{ items: CartItem[] }> {
    const resp = await apiClient.get<{ items: CartItem[] }>('/saved-cart');
    return resp.data ?? { items: [] };
  },

  /** Replace the entire cart on the backend. */
  async saveCart(items: CartItem[]): Promise<void> {
    await apiClient.put('/saved-cart', { items });
  },

  /** Clear the cart on the backend. */
  async clearCart(): Promise<void> {
    await apiClient.delete('/saved-cart');
  },
};
